<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1100px"
      line-form
      :title="(isEdit?'审核':'查看')+' 费用单'"
      edit-title
      id-key="DocId"
      :data="data"
      :get-data-func="api.info"
      form-label-width="95px"
      @details-opened="onDetailsOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row class="border">
          <el-row>
            <el-col :span="isMB?24:6">
              <el-form-item label="费用单编号">
                <span class="detail-span">{{data.DocNo}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:6">
              <el-form-item label="单据日期">
                <span class="detail-span">{{$commonJs.toDateString(data.DocDate)}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:6">
              <el-form-item label="单位名称">
                <span class="detail-span">{{data.TradeUnitName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:6">
              <el-form-item label="票据类型">
                <span class="detail-span">{{data.InvoiceTypeName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:6">
              <el-form-item label="业务类型">
                <span class="detail-span">{{data.BusinessType}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:6">
              <el-form-item label="经办人">
                <span class="detail-span">{{data.ClerkName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <span class="detail-span">{{data.Remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <template v-if="data.InvoiceTypeId!=null">
          <edit-list2 v-if="data.InvoiceTypeName=='收据'" ref="editList" is-detail />
          <edit-list1 v-else ref="editList" is-detail />
        </template>
        <div class="row-tb-head" style="margin-top: 10px;">
          <span>付款信息</span>
        </div>
        <el-table border class="table-line tb-c-head" :data="data.RpCostDocPayDtos">
          <el-table-column prop="SettleName" label="结算方式" min-width="110" />
          <el-table-column prop="AccountName" label="付款账号" />
          <el-table-column prop="PayAmount" label="付款金额" />
        </el-table>
      </template>
      <template slot="footer" slot-scope="{isLoading}">
        <template v-if="data.Status<2&&isEdit">
          <el-button :loading="isLoading" type="success" @click="save('examine')">审 核</el-button>
        </template>
        <template v-if="data.Status==2">
          <el-button :loading="isLoading" type="danger" @click="save('cancel')">弃 审</el-button>
        </template>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import editList1 from "./editList1";
import editList2 from "./editList2";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    editList1,
    editList2,
  },
  data() {
    return {
      api: require("@/api/rp/costDoc").default,
      data: {
        DocId: 0,
        DocNo: "", //编号
        DocDate: this.$commonJs.getToday(), //单据日期
        TradeUnitId: null, //往来单位Id
        TradeUnitName: "",
        UnitType: 0, //类型 - 1:零售 2:批发 3:供应商
        // DocType: null,
        SourceDocId: null,
        SourceDocNo: "",
        SourceBillName: "",
        BusinessTypeId: null, //业务类型
        BusinessType: "",
        InvoiceTypeId: null, //票据类型 - 0:不开票 SY_InvoiceType
        InvoiceTypeName: "",
        ClerkId: null, //经办人
        ClerkName: "",
        Amount: null, //金额
        TaxAmount: null, //税额
        IncTaxAmount: null, //含税金额
        NoTaxAmount: null, //无税金额
        ReceiptAmount: null, //收款税额
        RemainAmount: null, //剩余金额
        Remark: "", //备注
        Status: 0,

        RpCostDocPayDtos: [],
        RpCostDocDtsDtos: [],
      },
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    onDetailsOpened() {
      this.$nextTick(() => {
        this.$refs.editList.setData(this.data.RpCostDocDtsDtos);
      });
    },
    onEditOpened(data) {
      console.log("编辑", data);
      this.isEdit = true;
      this.$nextTick(() => {
        this.$refs.editList.setData(this.data.RpCostDocDtsDtos);
      });
    },
    save(type) {
      this.$refs.dialog.isLoading = true;
      this.api[type](this.data.DocId).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onClosed() {
      this.isEdit = false;
      this.data.RpCostDocPayDtos = [];
      this.data.RpCostDocDtsDtos = [];
    },
  },
};
</script>